import { Ref } from 'vue';
import { HekateDisplayForm, HekateDisplayField } from 'www-shared';
import hekateBus from '../../../../../bus';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class EduFormProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    super.realtimeBranchModifications({ formDefinition });

    EduFormProgressiveProfile.getRedirectValues();
    EduFormProgressiveProfile.changePrivacyLanguageForEDU({ formDefinition });
  }

  public static getRedirectValues(): void {
    if (!window.sessionStorage) return;
    const redirectValues = window.sessionStorage.getItem('EduRedirectFormValues');

    if (redirectValues === null) {
      return;
    }

    const prefillValues: string[][] = Object.entries(JSON.parse(redirectValues));

    prefillValues.forEach(([key, val]: string[]) => {
      hekateBus.dispatchEvent('form-inject-value', {
        fieldName: key,
        fieldValue: val,
      });
    });
  }

  private static changePrivacyLanguageForEDU({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>
  }): void {
    const privacyField:HekateDisplayField = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: 'privacyConsentAccepted' });
    // eslint-disable-next-line max-len
    privacyField.name = 'I acknowledge that my personal details will be processed in accordance with Onshape’s Privacy Policy.  PTC will not use student email addresses for any marketing purposes.';
  }

  private fieldNameMappingForHandoff: {[key:string]: string} = {
    firstName: 'firstname',
    lastName: 'lastname',
    eduRole: 'educationtype',
    schoolLevel: 'schoollevel',
    utm_term: 'keyword_term',
  };

  public onSuccess({
    formDefinition,
    redirectUrl,
  }: {
    formDefinition: Ref<HekateDisplayForm>
    redirectUrl: string | null,
  }): void {
    super.onSuccess({ formDefinition, redirectUrl });

    this.redirectToSignup2({ formDefinition });
  }

  // eslint-disable-next-line class-methods-use-this
  public onEloquaDown({
    formDefinition,
    redirectUrl,
  }: {
    formDefinition: Ref<HekateDisplayForm>,
    redirectUrl: string | null,
  }): void {
    super.onEloquaDown({ formDefinition, redirectUrl });
    this.redirectToSignup2({ formDefinition });
  }

  public redirectToSignup2({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>
  }): void {
    const whereTo = new URL('https://cad.onshape.com/signup2');

    whereTo.searchParams.set('basicdataid', 'DefaultEDUSignupForm1');
    whereTo.searchParams.set('extendeddataid', 'DefaultProductSignupForm2');
    whereTo.searchParams.set('enable_cookie', 'check');
    whereTo.searchParams.set('locale', 'en_US');
    whereTo.searchParams.set('approveUser', 'yes');
    whereTo.searchParams.set('planid', 'EDU_YEARLY');

    formDefinition.value.displayFields.forEach((field: HekateDisplayField) => {
      if (!field.val) return;
      // handle eloqua length issue
      if (field.htmlName === 'privacyConsentAccepted') {
        whereTo.searchParams.set('explicit_consent_for_data_processing_and_communica', 'Yes');
        // handle if eloqua fixes this
        whereTo.searchParams.set('explicit_consent_for_data_processing_and_communications', 'Yes');
      }

      const searchParamName = this.fieldNameMappingForHandoff[field.htmlName] || field.htmlName;

      whereTo.searchParams.set(searchParamName, `${field.val}`);
    });

    document.location = whereTo.href;
  }
}
